export default function togglePasswordVisibility() {
    $('body').on('click', '.js-toggle-password-visibility', function () {
        const $input = $(this).siblings('input');
        const type = $input.attr('type') === 'password' ? 'text' : 'password';
        $input.attr('type', type);
        $(this).toggleClass('is-visible', type === 'text');
    });
}
